import { fieldError } from "../../fieldRules"

export const EMPTY_RESTRICTION_FORM = { email: "", roleId: null, maxValue: "" }

export const toRestrictionForm = (row) => ({
  email: row.email || "",
  roleId: row.roleId ?? null,
  maxValue: String(row.maxValue ?? ""),
})

// max_value is numeric(18, 2); anything larger overflows the column.
const MAX_VALUE_LIMIT = 1e16

export const validateRestrictionForm = ({ email, roleId, maxValue }) => {
  const errors = {}
  if (!email.trim() && roleId == null) errors.target = "Enter an email or select a role."
  const emailError = fieldError(email, { max: 255, pattern: "email" })
  if (emailError) errors.email = emailError
  if (maxValue === "") errors.maxValue = "Max value is required."
  else if (Number(maxValue) >= MAX_VALUE_LIMIT) errors.maxValue = "Max value is too large."
  return errors
}

// PUT replaces every field, so a cleared email/role must be sent as null.
export const toRestrictionPayload = ({ email, roleId, maxValue }) => ({
  email: email.trim() || null,
  roleId: roleId ?? null,
  maxValue: Number(maxValue),
})
